import { FileText } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

export function PlaceholderPage({ title, description, icon }: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="page-title text-xl font-bold text-slate-900 sm:text-3xl">{title}</h1>
        <p className="text-slate-600 mt-1">{description}</p>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 p-16 flex flex-col items-center justify-center min-h-96">
        <div className="text-6xl mb-4">{icon || <FileText className="h-16 w-16 text-slate-400" />}</div>
        <h2 className="text-2xl font-semibold text-slate-900 mb-2">در حال توسعه</h2>
        <p className="text-slate-600 text-center">
          این بخش در حال توسعه است و به زودی قابل استفاده خواهد بود.
        </p>
      </div>
    </div>
  );
}
